var _rect, _path, _path2, _g, _path3, _path4, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCanvasNavMouseSlideHorizontally = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 61,
    viewBox: "0 0 102 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.167969,
    width: 100,
    height: 56,
    rx: 10,
    fill: "#9C64FF",
    fillOpacity: 0.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.2992 19.5848V21.9522M70.2992 36.1566C75.5292 36.1566 79.7688 31.9169 79.7688 26.687V21.9522C79.7688 16.7222 75.5292 12.4826 70.2992 12.4826C65.0693 12.4826 60.8296 16.7222 60.8296 21.9522V26.687C60.8296 31.9169 65.0693 36.1566 70.2992 36.1566Z",
    stroke: "#50307E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5029 22.3417L88.5029 20.3417M86.5029 22.3417L84.5029 20.3417M86.5029 22.3417L86.5029 18.5062L86.5029 14.6707",
    stroke: "#50307E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4145_3617)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-1_4145_3617",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.7758 22.2261C70.7758 20.562 72.1248 19.213 73.7888 19.213C75.4529 19.213 76.8019 20.562 76.8019 22.2261V29.5103C78.8984 29.6979 81.2056 30.0375 82.5638 30.377C84.5939 30.8845 87.1316 32.6859 87.1316 35.4524L87.1317 39.5127C87.1317 41.0353 86.7238 46.1114 79.0608 46.1114C75.9222 46.1114 74.0691 45.34 72.975 44.0825L65.409 36.5165C64.2323 35.3398 64.2323 33.432 65.409 32.2554C66.5857 31.0787 68.4934 31.0787 69.6701 32.2554L70.7758 33.3611V22.2261Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.7758 22.2261C70.7758 20.562 72.1248 19.213 73.7888 19.213C75.4529 19.213 76.8019 20.562 76.8019 22.2261V29.5103C78.8984 29.6979 81.2056 30.0375 82.5638 30.377C84.5939 30.8845 87.1316 32.6859 87.1316 35.4524L87.1317 39.5127C87.1317 41.0353 86.7238 46.1114 79.0608 46.1114C75.9222 46.1114 74.0691 45.34 72.975 44.0825L65.409 36.5165C64.2323 35.3398 64.2323 33.432 65.409 32.2554C66.5857 31.0787 68.4934 31.0787 69.6701 32.2554L70.7758 33.3611V22.2261Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.8019 29.5103H74.8019V31.3394L76.6237 31.5024L76.8019 29.5103ZM82.5638 30.377L83.0488 28.4367L82.5638 30.377ZM87.1316 35.4524H85.1316V35.4524L87.1316 35.4524ZM87.1317 39.5127H89.1317V39.5127L87.1317 39.5127ZM72.975 44.0825L74.4839 42.7697L74.4383 42.7174L74.3892 42.6683L72.975 44.0825ZM65.409 36.5165L63.9948 37.9307H63.9948L65.409 36.5165ZM65.409 32.2554L66.8232 33.6696L66.8232 33.6696L65.409 32.2554ZM69.6701 32.2554L68.2559 33.6696L69.6701 32.2554ZM70.7758 33.3611L69.3616 34.7753L72.7758 38.1895V33.3611H70.7758ZM73.7888 17.213C71.0202 17.213 68.7758 19.4574 68.7758 22.2261H72.7758C72.7758 21.6666 73.2293 21.213 73.7888 21.213V17.213ZM78.8019 22.2261C78.8019 19.4574 76.5575 17.213 73.7888 17.213V21.213C74.3483 21.213 74.8019 21.6666 74.8019 22.2261H78.8019ZM78.8019 29.5103V22.2261H74.8019V29.5103H78.8019ZM83.0488 28.4367C81.5471 28.0613 79.1242 27.7101 76.9801 27.5183L76.6237 31.5024C78.6725 31.6857 80.864 32.0136 82.0787 32.3173L83.0488 28.4367ZM89.1316 35.4524C89.1316 33.4071 88.1816 31.774 86.9999 30.6304C85.8385 29.5064 84.3758 28.7684 83.0488 28.4367L82.0787 32.3173C82.7819 32.4931 83.6031 32.9095 84.2181 33.5047C84.8128 34.0803 85.1316 34.7312 85.1316 35.4524H89.1316ZM89.1317 39.5127L89.1316 35.4524L85.1316 35.4524L85.1317 39.5127L89.1317 39.5127ZM79.0608 48.1114C83.3747 48.1114 86.0679 46.6516 87.5881 44.5583C89.0224 42.5833 89.1317 40.4129 89.1317 39.5127H85.1317C85.1317 40.1352 85.0369 41.2641 84.3516 42.2078C83.7521 43.0332 82.4099 44.1114 79.0608 44.1114V48.1114ZM71.4661 45.3952C73.0932 47.2654 75.6269 48.1114 79.0608 48.1114V44.1114C76.2174 44.1114 75.0449 43.4147 74.4839 42.7697L71.4661 45.3952ZM74.3892 42.6683L66.8232 35.1023L63.9948 37.9307L71.5608 45.4967L74.3892 42.6683ZM66.8232 35.1023C66.4276 34.7067 66.4276 34.0652 66.8232 33.6696L63.9948 30.8412C62.0371 32.7989 62.0371 35.973 63.9948 37.9307L66.8232 35.1023ZM66.8232 33.6696C67.2188 33.274 67.8603 33.274 68.2559 33.6696L71.0843 30.8412C69.1266 28.8834 65.9525 28.8834 63.9948 30.8412L66.8232 33.6696ZM68.2559 33.6696L69.3616 34.7753L72.19 31.9468L71.0843 30.8412L68.2559 33.6696ZM68.7758 22.2261V33.3611H72.7758V22.2261H68.7758Z",
    fill: "#50307E",
    mask: "url(#path-4-inside-1_4145_3617)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5029 9.88858L86.5029 17.5595M86.5029 9.88858L84.5029 11.8886M86.5029 9.88858L88.5029 11.8886",
    stroke: "#50307E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.833 21.998C48.833 21.4457 48.3853 20.998 47.833 20.998C47.2807 20.998 46.833 21.4457 46.833 21.998V26.998H41.833C41.2807 26.998 40.833 27.4457 40.833 27.998C40.833 28.5502 41.2807 28.998 41.833 28.998H46.833V33.998C46.833 34.5502 47.2807 34.998 47.833 34.998C48.3853 34.998 48.833 34.5502 48.833 33.998V28.998H53.833C54.3853 28.998 54.833 28.5502 54.833 27.998C54.833 27.4457 54.3853 26.998 53.833 26.998H48.833V21.998Z",
    fill: "#50307E"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_4145_3617)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4967 17.1151C14.6635 17.1151 12.2725 19.303 12.2725 22.1151V34.1151C12.2725 36.9273 14.6635 39.1151 17.4967 39.1151H30.1693C33.0025 39.1151 35.3936 36.9273 35.3936 34.1151V22.1151C35.3936 19.303 33.0025 17.1151 30.1693 17.1151H17.4967Z",
    fill: "white",
    stroke: "#50307E",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3355 31.2087C15.8935 31.2087 15.4957 31.1229 15.1421 30.9513C14.7885 30.7745 14.5025 30.5301 14.2841 30.2181L15.2357 29.4147C15.3709 29.6123 15.5451 29.7683 15.7583 29.8827C15.9715 29.9919 16.1795 30.0465 16.3823 30.0465C16.5903 30.0465 16.7541 30.0049 16.8737 29.9217C16.9933 29.8333 17.0531 29.7215 17.0531 29.5863C17.0531 29.4459 16.9933 29.3237 16.8737 29.2197C16.7593 29.1157 16.5617 29.0169 16.2809 28.9233L15.8909 28.7907C15.4385 28.6399 15.0927 28.4319 14.8535 28.1667C14.6143 27.8963 14.4947 27.5713 14.4947 27.1917C14.4947 26.9213 14.5415 26.6821 14.6351 26.4741C14.7339 26.2609 14.8665 26.0815 15.0329 25.9359C15.2045 25.7903 15.4073 25.6785 15.6413 25.6005C15.8753 25.5225 16.1301 25.4835 16.4057 25.4835C16.7437 25.4835 17.0609 25.5407 17.3573 25.6551C17.6537 25.7695 17.9319 25.9671 18.1919 26.2479L17.3807 27.1059C17.2507 26.9499 17.1025 26.8355 16.9361 26.7627C16.7697 26.6847 16.5981 26.6457 16.4213 26.6457C16.3381 26.6457 16.2549 26.6535 16.1717 26.6691C16.0937 26.6847 16.0235 26.7107 15.9611 26.7471C15.8987 26.7835 15.8467 26.8277 15.8051 26.8797C15.7687 26.9317 15.7505 26.9941 15.7505 27.0669C15.7505 27.2177 15.8181 27.3373 15.9533 27.4257C16.0937 27.5089 16.3121 27.6025 16.6085 27.7065L16.9985 27.8469C17.3989 27.9925 17.7187 28.2005 17.9579 28.4709C18.2023 28.7413 18.3219 29.0845 18.3167 29.5005C18.3167 29.7501 18.2673 29.9815 18.1685 30.1947C18.0697 30.4027 17.9319 30.5821 17.7551 30.7329C17.5835 30.8837 17.3755 31.0007 17.1311 31.0839C16.8919 31.1671 16.6267 31.2087 16.3355 31.2087ZM18.7081 25.5771H19.9483V27.7455H22.1791V25.5771H23.4193V31.1151H22.1791V28.9233H19.9483V31.1151H18.7081V25.5771ZM24.1205 25.5771H25.3607V31.1151H24.1205V25.5771ZM26.0596 25.5771H29.4682V26.7627H27.2998V27.7611H28.9924V28.9467H27.2998V31.1151H26.0596V25.5771ZM30.8404 26.7627H29.4286V25.5771H33.5158V26.7627H32.0884V31.1151H30.8404V26.7627Z",
    fill: "#50307E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4145_3617",
    x: 58.5265,
    y: 13.213,
    width: 42.6051,
    height: 46.8984,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.313726 0 0 0 0 0.188235 0 0 0 0 0.494118 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4145_3617"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4145_3617",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_4145_3617",
    x: 5.27246,
    y: 10.1151,
    width: 45.1211,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.313726 0 0 0 0 0.192157 0 0 0 0 0.494118 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4145_3617"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4145_3617",
    result: "shape"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCanvasNavMouseSlideHorizontally);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/canvas_nav_mouse_slide_horizontally.8739ad877a511c3802de2fc7e2e4eda9.svg";